export default __webpack_public_path__ + "static/bridge-4914a5dd733705c86d7e6d7fef646757.png";